export default
{
    en: {
        AGREEMENT_DIALOG_TITLE: 'Cybersafe Agreements',
        ACCEPT_AGREEMENTS_DISCLAIMER_TEXT: 'By checking this box, I agree to all terms and conditions listed above.',
        AGREEMENT_DIALOG_CONFIRM_TEXT: 'Accept'
    }
}
